/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

import { supportsWebp } from "./functions/browser";

require("./trans");
require("./registration");
require("./messenger/facebook/facebookMessengerOptIn");

if (supportsWebp()) {
  document.body.classList.add("webp");

  const lazyWebp = document.querySelectorAll(".lazy.webp");

  for (let i = 0; i < lazyWebp.length; i++) {
    lazyWebp[i].dataset.src = lazyWebp[i].dataset.src
      .replace("png", "webp")
      .replace("jpg", "webp");
  }
}

/**
 * Smooth Scrolling
 */
// jQuery('a[href*="#"]').on('click',function(e) {
//     const targetElement = e.target;

//     if (targetElement.dataset.toggle != 'tab' && targetElement.dataset.toggle != 'collapse'){
//         e.preventDefault();
//         var offset = 120;
//         var target = this.hash;
//         if (target != '') {
//             if (jQuery(this).data('offset') != undefined) offset = jQuery(this).data('offset');
//             jQuery('html, body').stop().animate({
//                 'scrollTop': jQuery(target).offset().top - offset
//             }, 500, 'swing', function() {
//                 // window.location.hash = target;
//             });
//         }
//     }
// });

/**
 * Widget auf Consultation-Seite erst einblenden, wnen an Google-Reviews vorbei
 */
window.addEventListener("DOMContentLoaded", function () {
  var consultationSite = document.getElementById("consultation-site");
  var widget = document.getElementById("ProvenExpert_widget_container");

  if (consultationSite && widget) {
    widget.style.display = "none";
  }
});

window.addEventListener("scroll", function () {
  var elementTarget = document.getElementById("slider-reviews-consultation");
  var widget = document.getElementById("ProvenExpert_widget_container");

  if (widget && elementTarget && window.innerWidth > 991) {
    if (window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight) {
      widget.style.display = "block";
    }

    if (
      window.scrollY <=
      elementTarget.offsetTop + elementTarget.offsetHeight
    ) {
      widget.style.display = "none";
    }
  }

  if (widget && elementTarget && window.innerWidth <= 991) {
    widget.style.display = "none";
  }
});
